import React from "react";

// Orange "HOLD" pill shown next to a supplier's quantity when that
// product_supplier row is on hold. `onHoldAt` is the ISO datetime the hold
// started (product_suppliers.on_hold_at); null/undefined renders nothing.
//
// Uses a native `title` rather than an antd <Tooltip> on purpose: on the orders
// index each residues <tr> is already wrapped in a Tooltip showing the supplier
// name, and nesting a second one there causes hover conflicts.
function OnHoldBadge({ onHoldAt, className = "" }) {
  if (!onHoldAt) return null;

  const since = String(onHoldAt).slice(0, 10);

  return (
    <span
      className={`badge badge-pill badge-on-hold text-xs px-2 font-normal ${className}`}
      title={`On hold since ${since}`}
    >
      HOLD
    </span>
  );
}

export default OnHoldBadge;
